import { Container, Row, Col, Card } from "react-bootstrap";

export default function Irrigation() {
  return (
    <Container fluid className="py-5 bg-white">
      <h2 className="text-center text-primary fw-bold">Irrigation</h2>
      <p className="mt-3 text-center text-secondary fs-5">
        We develop sustainable irrigation infrastructure to optimize water resources for agriculture and rural development.
      </p>

      <Row className="mt-4 justify-content-center g-4">
        <Col xs={12} md={6} lg={4}>
          <Card className="shadow border-0" style={{padding: "5px" }}>
            <Card.Body>
              <Card.Title className="text-primary fw-bold">Canal Systems</Card.Title>
              <Card.Text className="text-secondary">
                Building extensive canal networks for efficient water distribution.
              </Card.Text>
            </Card.Body>
          </Card>
        </Col>

        <Col xs={12} md={6} lg={4} className="d-flex justify-content-center">
          <Card className="shadow border-0" style={{padding: "5px" }}>
            <Card.Body>
              <Card.Title className="text-primary fw-bold">Dams & Reservoirs</Card.Title>
              <Card.Text className="text-secondary">
                Constructing large-scale dams and reservoirs for water conservation.
              </Card.Text>
            </Card.Body>
          </Card>
        </Col>
      </Row>
    </Container>
  );
}
